import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../../lib/api';
import { Input } from '../ui/input';
import { SectionCard } from './SectionCard';
import { Plus, Trash2 } from 'lucide-react';

export default function GalleryManager({ onSaved, toast }) {
  const [items, setItems] = useState([]);
  const [url, setUrl] = useState('');
  const load = useCallback(async () => { try { const { data } = await api.get('/admin/gallery'); setItems(data); } catch { /* ignore */ } }, []);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    if (!url) return;
    await api.post('/admin/gallery', { image: url, sort_order: items.length });
    setUrl(''); load(); onSaved && onSaved();
    toast({ title: 'Image added' });
  };
  const remove = async (id) => { if (!window.confirm('Delete?')) return; await api.delete(`/admin/gallery/${id}`); load(); onSaved && onSaved(); };

  return (
    <SectionCard title="Gallery" subtitle={`${items.length} images`}>
      <div className="flex gap-2 mb-4">
        <Input data-testid="gallery-url-input" placeholder="Paste image URL here..." value={url} onChange={e => setUrl(e.target.value)} className="flex-1" />
        <button data-testid="add-gallery-btn" onClick={add} className="btn-brand text-sm"><Plus className="w-4 h-4" /> Add</button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
        {items.map(it => (
          <div key={it.id} className="relative group aspect-square">
            <img src={it.image} alt="" className="w-full h-full object-cover rounded border" />
            <button onClick={() => remove(it.id)} className="absolute top-1 right-1 p-1.5 bg-white/95 text-red-600 hover:bg-red-50 rounded opacity-0 group-hover:opacity-100 transition-opacity"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
    </SectionCard>
  );
}
